import { createApp } from 'vue'
import store from './store/index.js'
import router from './router.js'
import App from './App.vue'

/**
 * Import componentes base
 */
import BaseButton from './components/UI/BaseButton.vue'
import BotonVerMas from './components/BotonVerMas.vue'
import BaseCard from './components/UI/BaseCard.vue'
import BaseMenu from './components/UI/BaseMenu.vue'
import BaseSubMenu from './components/UI/BaseSubMenu.vue'
import BaseContainer from './components/UI/BaseContainer.vue'
import BaseFilter from './components/UI/BaseFilter.vue'
import ControlBox from './components/UI/ControlBox.vue'
import BaseVideo from './components/UI/BaseVideo.vue'
import BaseSlider from './components/UI/BaseSlider.vue'
import BaseIcon from './components/UI/BaseIcon.vue'
import FloatButton from './components/UI/BasicFloatButton.vue'

/**
 * Import SVGs
 */
import IconFacebook from './components/UI/icons/iconFacebook';
import IconInstagram from './components/UI/icons/iconInstagram.vue';
import IconYoutube from './components/UI/icons/iconYoutube.vue';
import IconLogo from './components/UI/icons/iconLogo.vue';
import IconIsotipoLogo from './components/UI/icons/iconIsotipoLogo.vue';
import IconMap from './components/UI/icons/iconMap.vue';
import IconMail from './components/UI/icons/iconMail.vue';
import IconLineas from './components/UI/icons/iconoLineas.vue';
import IconLineasDerecha from './components/UI/icons/iconLineasDerecha.vue';
import IconLineasIzquierda from './components/UI/icons/iconLineasIzquierda.vue';
import IconLineasEducacion from './components/UI/icons/iconLineaEducacion.vue';
import IconDice from './components/UI/icons/iconDice.vue'
import IconMicro from './components/UI/icons/iconMicro.vue'
import IconLibros from './components/UI/icons/iconLibros.vue'
import IconFoco from './components/UI/icons/iconFoco.vue'
import IconMensaje from './components/UI/icons/iconMensaje.vue'
import IconTaller from './components/UI/icons/iconTaller.vue'
import IconELRCA from './components/UI/icons/iconELRCA.vue' 
import IconUbicacion from './components/UI/icons/iconUbicacion.vue'
import IconFeria from './components/UI/icons/iconFeria.vue'

/**
 * Import fontawesome
 */
import { library, config } from '@fortawesome/fontawesome-svg-core'
// Make sure this is before any other `fontawesome` API calls
config.autoAddCss = false

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
        faTimes, faBars, faChevronCircleLeft, faChevronCircleRight,faChevronRight, faChevronLeft,
        // faHome, add new icons here
    } 
        from '@fortawesome/free-solid-svg-icons'
// import {   } from '@fortawesome/pro-regular-svg-icons'
// import { faFontAwesome, faFacebookF, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import './assets/tailwind.css'

library.add(faBars,faTimes, faChevronCircleRight, faChevronCircleLeft, 
    faChevronRight, faChevronLeft, 
    // faHome, add new icons here too
    )

/***
 * Crear Main app
 */

const app = createApp(App)

// Add fontawesonicon to Main app
app.component('FontIcon', FontAwesomeIcon)
// Add congig to Main app
app.config.productionTip = false
// Add globalproperties to Main app - identifico app
app.config.globalProperties = {$applocation: "main"}

// Add router, store and components to Main app
app.use(router)
app.use(store)
app.component('BaseCard', BaseCard)
app.component('BaseButton', BaseButton)
app.component('BotonVerMas', BotonVerMas)
app.component('BaseSubMenu', BaseSubMenu)
app.component('BaseMenu', BaseMenu)
app.component('BaseContainer', BaseContainer)
app.component('BaseFilter', BaseFilter)
app.component('BaseVideo', BaseVideo)
app.component('ControlBox', ControlBox)
app.component('BaseSlider', BaseSlider)
app.component('BaseIcon', BaseIcon)
app.component('FloatButton', FloatButton)

app.component('IconYoutube', IconYoutube)
app.component('IconFacebook', IconFacebook)
app.component('IconInstagram', IconInstagram)
app.component('IconLogo', IconLogo)
app.component('IconIsotipoLogo', IconIsotipoLogo)
app.component('IconMail', IconMail)
app.component('IconMap', IconMap)
app.component('IconLineas', IconLineas)
app.component('IconLineasDerecha', IconLineasDerecha)
app.component('IconLineasIzquierda', IconLineasIzquierda)
app.component('IconLineasEducacion', IconLineasEducacion)
app.component('IconMicro', IconMicro)
app.component('IconFoco', IconFoco)
app.component('IconLibros', IconLibros)
app.component('IconMensaje', IconMensaje)
app.component('IconDice', IconDice)
app.component('IconTaller', IconTaller)
app.component('IconElrca', IconELRCA)
app.component('IconUbicacion', IconUbicacion)
app.component('IconFeria', IconFeria)
// monto Main app
app.mount('#app')

/***
 * Crear appfooter
 */
// const footerapp = createApp(App)
// // Add fontawesonicon to Main app
// footerapp.component('FontIcon', FontAwesomeIcon)
// // Add congig to Main app
// footerapp.config.globalProperties = {$applocation: "footer"}
// // Add globalproperties to Main app - identifico app
// footerapp.config.productionTip = false

// Add router, store and components to Main app
// footerapp.use(router)
// footerapp.use(store)
// footerapp.component('BaseCard', BaseCard)
// footerapp.component('BaseButton', BaseButton)
// footerapp.component('BotonVerMas', BotonVerMas)
// footerapp.component('BaseSubMenu', BaseSubMenu)
// footerapp.component('BaseMenu', BaseMenu)
// footerapp.component('BaseContainer', BaseContainer)
// footerapp.component('BaseFilter', BaseFilter)
// footerapp.component('BaseVideo', BaseVideo)
// footerapp.component('ControlBox', ControlBox)
// footerapp.component('BaseSlider', BaseSlider)
// footerapp.component('BaseIcon', BaseIcon)
// footerapp.component('FloatButton', FloatButton)

// footerapp.component('IconYoutube', IconYoutube)
// footerapp.component('IconFacebook', IconFacebook)
// footerapp.component('IconInstagram', IconInstagram)
// footerapp.component('IconLogo', IconLogo)
// footerapp.component('IconIsotipoLogo', IconIsotipoLogo)
// footerapp.component('IconMail', IconMail)
// footerapp.component('IconMap', IconMap)
// footerapp.component('IconLineas', IconLineas)
// footerapp.component('IconLineasDerecha', IconLineasDerecha)
// footerapp.component('IconLineasIzquierda', IconLineasIzquierda)
// footerapp.component('IconLineasEducacion', IconLineasEducacion)
// footerapp.component('IconMicro', IconMicro)
// footerapp.component('IconFoco', IconFoco)
// footerapp.component('IconLibros', IconLibros)
// footerapp.component('IconMensaje', IconMensaje)
// footerapp.component('IconDice', IconDice)
// footerapp.component('IconTaller', IconTaller)
// footerapp.component('IconElrca', IconELRCA)
// // monto footer app
// footerapp.mount('#footerapp','footerapp')